module.exports = __webpack_public_path__ + "img/playroom.45c3c194.svg";